import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { images } from "helpers/images";

export const NotFoundLayout = () => {
  return (
    <div className="flex flex-col items-center justify-center overflow-y-hidden h-screen relative !pt-10">
      <Link to="/portal/dashboard">
        <img
          className="w-[171.25px] h-[40px]"
          src={images.Zynerd_logo_blue}
          alt="logo"
        />
      </Link>
      <div className={` h-full flex items-center justify-center p-5 w-full`}>
        <div className="flex flex-col items-start gap-5 p-11">
          <p className="text-4xl font-[900]">Page not found</p>
          <p className="text-xl font-[500]">
            This page might not have made the cut-off, but your seat to success
            is still open. Let's help you find it.
          </p>
          <Link to={`/portal/dashboard`}>
            <button className="text-[16px] font-[700] max-w-[380px] mx-auto py-[8px] px-[34px] text-white rounded-[4px]  flex items-center justify-center gap-[8px] text-center bg-[#F46C3C] hover:bg-[#D74B1A]">
              Back to Dashboard
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
              >
                <path
                  d="M14 4.5L21.5 12M21.5 12L14 19.5M21.5 12H3.5"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </Link>
        </div>
        <img
          className="w-[726px] h-[726px] "
          src={images.NotFound}
          alt="not Found"
        />
      </div>
    </div>
  );
};

export default NotFoundLayout;
